import { useLocation } from "react-router-dom";
import React from "react";

import { all_routes } from "../router/all_routes";

export interface breadcrumbs {
  title: string;
  subtitle: string;
}

const Breadcrumbs = (props: breadcrumbs) => {
  const routes = all_routes;
  const location = useLocation();
  let addButton = null;
  if (
    location.pathname === routes.listingGrid ||
    location.pathname === routes.booking ||
    location.pathname === routes.invoice ||
    location.pathname === routes.listingDetails ||
    location.pathname === routes.ourTeam ||
    location.pathname === routes.testimonial ||
    location.pathname === routes.termsConditions ||
    location.pathname === routes.privacyPolicy ||
    location.pathname === routes.aboutUs ||
    location.pathname === routes.pricing ||
    location.pathname === routes.faq ||
    location.pathname === routes.gallery ||
    location.pathname === routes.blogList ||
    location.pathname === routes.blogGrid ||
    location.pathname === routes.contactUs
  ) {
    addButton = (
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">{props.title}</h2>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (
    location.pathname === routes.userMessages ||
    location.pathname === routes.userPayment ||
    location.pathname === routes.userReviews ||
    location.pathname === routes.userBookings ||
    location.pathname === routes.userBookingUpcoming ||
    location.pathname === routes.userBookingCancelled ||
    location.pathname === routes.userBookingInprogress ||
    location.pathname === routes.userBookingComplete ||
    location.pathname === routes.userWallet ||
    location.pathname === routes.userIntegration ||
    location.pathname === routes.bookingCheckout ||
    location.pathname === routes.bookingDetail ||
    location.pathname === routes.bookingPayment ||
    location.pathname === routes.bookingSuccess ||
    location.pathname === routes.bookingCheckout
  ) {
    addButton = (
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">{props.title}</h2>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    addButton = <></>;
  }
  return <>{addButton}</>;
};

export default Breadcrumbs;
